import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/contact/send_email_small.svg';
const SendEmailSvg = () => React.createElement(IconSvg, null);
export default SendEmailSvg;
